export default defineNuxtPlugin(() => {
  window.setTimeout(() => {
    void import('flag-icons/css/flag-icons.min.css')
  }, 1000)
})
